import { createContext } from 'react';

const AccessKeySinkContext = createContext();

export default AccessKeySinkContext;
